import containerComponent from './container';

export default function container(picasso) {
  picasso.component('container', containerComponent);
}
